import { TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import axios from 'axios';
import { formatError } from 'components/utils/FormatData';
import moment from 'moment';
import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { Form, TextArea } from 'semantic-ui-react';
import { URL_API } from '../../constants/settings';


const BasicTab = (props) => {
  const { auth, headers, datas, columns, width, style, openExternalTab, showDetail, handleOpenDetail, showResponse, handleOpenResponse, showLog, handleOpenLog } = props;
  const [editMode, setEditMode] = useState(false);
  const [url, setUrl] = useState();
  const [pilotable, setPilotable] = useState({
    value: null,
    init: false,
  });
  const [originValue, setOriginValue] = useState();
  const [initUrl, setInitUrl] = useState(false);
  const alert = useAlert();

  const handleOnChangeUrl = (value) => {
    setUrl(value);
  };
  const handleOnClickEditUrl = (value) => {
    setUrl(value);
    setOriginValue(value);
    setEditMode(true);
  };
  const handleOnLeave = () => {
    if (url !== originValue) {
      axios({ method: 'put', url: URL_API + '/equipements/' + datas.id + '/url', params: { url: url } })
        .then(function () {
          alert.success(`L'adresse de la page d'administration de l'équipement [${datas.id}] a bien été changé`);
          setEditMode(false);
        })
        .catch(function (err) {
          formatError(alert, err);
          setEditMode(false);
        });
    } else {
      setEditMode(false);
    }
  };
  const handleOnChangePilotable = (value) => {
    axios({ method: 'put', url: URL_API + '/equipements/' + datas.id + '/pilotable', params: { pilotable: !value } })
      .then(function (res) {
        setPilotable({ value: !value, init: true });
        alert.success(`L'élément indiquant si l'équipement [${datas.id}] accepte les commandes vient d'être modifié`);
      })
      .catch(function (err) {
        formatError(alert, err);
      });
  };
  const getClassNameFromColumnName = (column) => {
    switch (column) {
      case 'famille' :
        return 'famille';
      case 'autoroute':
        return 'autoroute';
      case 'sens':
        return 'sens';
      case 'pr':
        return 'pr';
      case 'pilotable':
        return 'pilotable'
      case 'equipementIdSociete' :
        return 'id';
      case 'acquitEtat':
      case 'priorite':
      case 'jobType' :
      case 'userStatus' :
        return 'etat';
      case 'dateDeb':
      case 'dateFin':
      case 'dateEnvoi':
      case 'acquitDate':
        return 'date';
      case 'utilisateur':
        return 'user';
      case 'symptome':
      case 'url':
      case 'eqpDescription':
      case 'jobDescription':
      case 'acquitMotifLibelle':
      case 'reponse':
      default:
        return null;
    }
  }
  const displayValueFromType = (value, column) => {
    switch (column) {
      case 'sens':
        return <div style={{ textAlign: 'center'}}>{value}</div>;
      case 'acquitEtat':
        if (value) {
          return (<div style={{ textAlign: 'center'}}><i className="color-vert cell-render-icon fas fa-circle" /></div>);
        } else {
          return (<div style={{ textAlign: 'center'}}><i className="color-rouge cell-render-icon fas fa-circle" /></div>);
        }
      case 'acquitMotifLibelle':
        return value ? <div style={{ textAlign: 'center' }}>{value}</div> : <div style={{ textAlign: 'center' }}>-</div>;
      case 'dateDeb':
      case 'dateFin':
      case 'dateEnvoi':
      case 'acquitDate':
        return value ? <div style={{ textAlign: 'center' }}>{moment(value).format('DD/MM/YYYY HH:mm')}</div> : <div style={{ textAlign: 'center' }}>-</div>;
      case 'priorite':
      case 'symptome':
        return value ? <div style={{ textAlign: 'center' }}>{value.code}</div> : <div style={{ textAlign: 'center' }}>-</div>;
      case 'utilisateur':
        return value ? <div style={{ textAlign: 'center' }}>{value.toUpperCase()}</div> : <div style={{ textAlign: 'center' }}>-</div>;
      case 'pilotable':
        if (!pilotable.value && !pilotable.init) {
          setPilotable({ value: value, init: true });
        }
        return (
          <div style={{ textAlign: 'center' }}>
            {
              props.wsStatus &&
              <Checkbox
                checked={pilotable.value}
                onClick={() => handleOnChangePilotable(pilotable.value)}
                color="default"
                disabled={auth.profil !== 1 && auth.profil !== 2}
              />
            }
            {
              !props.wsStatus &&
              <Checkbox
                checked={pilotable.value}
                color="default"
                disabled
              />
            }
          </div>
        );
      case 'url':
        if (!url && !initUrl) {
          setUrl(value);
          setInitUrl(true);
        }
        return (
          <div style={{ textAlign: 'center' }}>
            {
              editMode &&
              <TextField
                label=""
                type="text"
                value={url}
                onChange={(e) => handleOnChangeUrl(e.target.value)}
                onBlur={() => handleOnLeave()}
                style={{ minWidth: '250px' }}
                autoFocus
              />
            }
            {
              !editMode && props.wsStatus &&
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 15px', justifyContent: 'center' }}>
                <div className="div-with-url" onClick={() => openConfigEquipement()}>{url ? url : '-'}</div>
                {
                  (auth.profil === 1 || auth.profil === 2) &&
                  <i className="cell-render-icon-circle-background color-fond-vert fa fa-pen" onClick={() => handleOnClickEditUrl(url)} />
                }
              </div>
            }
            {
              (auth.profil === 1 || auth.profil === 2) && !editMode && !props.wsStatus &&
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 15px', justifyContent: 'center' }}>
                <div>{url ? url : '-'}</div>
                <i className="cell-render-icon-circle-background color-fond-gris fa fa-pen" style={{ cursor: 'default' }} />
              </div>
            }
          </div>
        );
      case 'eqpDescription':
      case 'jobDescription':
        return (<div style={{ textAlign: 'left' }}>{value}</div>);
      case 'commande':
      case 'reponse':
        return (
            <Form>
              <TextArea value={value ? value : ''} />
            </Form>
        );
      default:
        return value !== undefined && value !== null ? <div style={{ textAlign: 'center' }}>{value}</div> : <div style={{ textAlign: 'center' }}></div>;
    }
  };
  const openConfigEquipement = () => {
    if (url && (String(url).startsWith('http://') || String(url).startsWith('https://'))) {
      window.open(url, "_blank");
    } else {
      window.open('http://' + url, "_blank");
    }
  }

  return (
    <div className="basic-tab-container">
      {
        headers && headers.length > 0 && (datas && (datas.length > 0 || datas.id !== "")) &&
        <table className="basic-tab" style={{ width: width }}>
          <thead>
            <tr style={style?.header?.row ? style.header.row : {}}>
              {
                headers.map((h) => {
                  return <th key={'column-header-' + h}>{h}</th>;
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              datas && datas.length > 0 && datas.map((aRow, i) => {
                return (
                  <tr key={'row-datas-' + i} style={style?.datas?.row ? style.datas.row : {}}>
                    {
                      columns && columns.length > 0 && columns.map((aColumn, j) => {
                        const className = getClassNameFromColumnName(aColumn);
                        return <td className={className ? className : ''} key={'cell-data-' + i + '-' + j} style={style?.datas?.value ? style.datas.value : {}}>
                          {displayValueFromType(aRow[aColumn], aColumn)}
                        </td>;
                      })
                    }
                    <td style={style?.datas?.value ? style.datas.value : { display: 'flex' }}>
                      {
                        showDetail &&
                        <a href="#" onClick={() => {handleOpenDetail(aRow)}}><i className="cell-render-icon-circle-background fa fa-info"  /></a>
                      }
                      {
                        showResponse &&
                        <a href="#" onClick={() => {handleOpenResponse(aRow)}}><i className="cell-render-icon-circle-background fa fa-reply"  /></a>
                      }
                      {
                        showLog &&
                        <a href="#" onClick={() => {handleOpenLog(aRow)}}><i className="cell-render-icon-circle-background fa fa-info"  /></a>
                      }
                      {
                        openExternalTab && props.wsStatus &&
                        <a href={aRow[openExternalTab]} target="_blank"><i className="cell-render-icon-circle-background fa fa-external-link-alt" /></a>
                      }
                      {
                        openExternalTab && !props.wsStatus &&
                        <i className="cell-render-icon-circle-background fa fa-external-link-alt" style={{ backgroundColor: '#8ca0a8', cursor: 'default' }} />
                      }
                    </td>
                  </tr>
                );
              })
            }
            {
              datas && datas.length === undefined &&
              <tr style={style?.datas?.row ? style.datas.row : {}}>
                {
                  columns && columns.length > 0 && columns.map((aColumn, j) => {
                    const className = getClassNameFromColumnName(aColumn);
                    return <td className={className ? className : ''} key={'cell-data-0-' + j} style={style?.datas?.value ? style.datas.value : {}}>
                      {displayValueFromType(datas[aColumn], aColumn)}
                    </td>;
                  })
                }
                <td style={style?.datas?.value ? style.datas.value : { display: 'flex' }}>
                  {
                    showDetail &&
                    <i className="cell-render-icon-circle-background fas fa-info" onClick={() => handleOpenDetail(datas)} />
                  }
                  {
                    openExternalTab && props.wsStatus &&
                    <a href={datas[openExternalTab]} target="_blank"><i className="cell-render-icon-circle-background fa fa-external-link-alt" /></a>
                  }
                  {
                    openExternalTab && !props.wsStatus &&
                    <i className="cell-render-icon-circle-background fa fa-external-link-alt" style={{ backgroundColor: '#8ca0a8', cursor: 'default' }} />
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      {
        (datas && (datas.length === 0 || (datas.length === undefined && !datas.id))) &&
        <h5>Aucune donnée à afficher</h5>
      }
    </div>
  );

};

export default BasicTab;
